import React from "react";

/**
 * One line-icon family: 24px grid, 1.5px stroke, round joins.
 * Emoji were replaced with these so every section shares a single voice.
 */
const paths = {
  box: "M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5v-9Zm0 0L12 12m0 0 8.5-4.5M12 12v9",
  users:
    "M16 19v-1.5A3.5 3.5 0 0 0 12.5 14h-5A3.5 3.5 0 0 0 4 17.5V19m6-9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm10 9v-1.5a3.5 3.5 0 0 0-2.6-3.4M15.5 4.2a3 3 0 0 1 0 5.6",
  chart: "M4 20h16M7 16V9m5 7V5m5 11v-4",
  card: "M3 8.5h18M3 7.5A2.5 2.5 0 0 1 5.5 5h13A2.5 2.5 0 0 1 21 7.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16.5v-9ZM7 15h3",
  device:
    "M8.5 3h7A1.5 1.5 0 0 1 17 4.5v15A1.5 1.5 0 0 1 15.5 21h-7A1.5 1.5 0 0 1 7 19.5v-15A1.5 1.5 0 0 1 8.5 3Zm2.5 15h2",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-2 4 4",
  spark: "M12 3.5 13.8 9l5.7 1.9-5.7 1.9L12 20.5l-1.8-7.7L4.5 11l5.7-1.9L12 3.5Z",
  chat: "M20 12c0 4-3.6 7.2-8 7.2a9.5 9.5 0 0 1-2.7-.4L4 20.5l1.4-3.9A6.9 6.9 0 0 1 4 12c0-4 3.6-7.2 8-7.2s8 3.2 8 7.2Z",
  truck:
    "M3 7.5A1.5 1.5 0 0 1 4.5 6H14v9H3V7.5ZM14 9h3.6l2.4 3v3h-6V9Zm-7 9a1.8 1.8 0 1 0 0-3.6A1.8 1.8 0 0 0 7 18Zm10 0a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z",
  shield: "M12 3.5 19.5 6v6c0 4.3-3 7.5-7.5 9.5C7.5 19.5 4.5 16.3 4.5 12V6L12 3.5Zm-2.6 8.9 1.9 1.9 3.8-3.8",
  play: "M8.5 5.6 18 12l-9.5 6.4V5.6Z",
  arrowRight: "M4 12h15m-6-6 6 6-6 6",
  arrowUpRight: "M8 16 16.5 7.5M9 7.5h7.5V15",
  arrowUp: "M12 20V5m-6 6 6-6 6 6",
  check: "m5 12.5 4.5 4.5L19 7",
  close: "m6 6 12 12M18 6 6 18",
  menu: "M4 8h16M4 16h16",
  sun: "M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-13.5v2m0 15v2m9-9h-2M5 12H3m14.3-5.3-1.4 1.4M8.1 15.9l-1.4 1.4m10.6 0-1.4-1.4M8.1 8.1 6.7 6.7",
  moon: "M20 14.2A8.2 8.2 0 0 1 9.8 4 8.2 8.2 0 1 0 20 14.2Z",
  mail: "M3.5 7.5A1.5 1.5 0 0 1 5 6h14a1.5 1.5 0 0 1 1.5 1.5v9A1.5 1.5 0 0 1 19 18H5a1.5 1.5 0 0 1-1.5-1.5v-9Zm.6-.7 7 5.2a1.5 1.5 0 0 0 1.8 0l7-5.2",
  whatsapp:
    "M20 11.7c0 4.2-3.5 7.6-7.8 7.6a7.9 7.9 0 0 1-3.7-.9L4 20l1.7-4.3a7.4 7.4 0 0 1-1.3-4c0-4.2 3.5-7.6 7.8-7.6S20 7.5 20 11.7Zm-11.3-3c.6-.1.8.1 1 .5l.7 1.5c.1.3 0 .5-.1.7l-.4.5c-.2.2-.2.4-.1.6.4.8 1.4 1.7 2.3 2.1.3.1.5 0 .6-.1l.5-.6c.2-.2.4-.2.6-.1l1.5.7c.4.2.5.4.4.9-.2.8-1.1 1.3-2 1.2-1.6-.2-3.4-1.3-4.6-2.5-1-1-1.7-2.3-1.8-3.4-.1-.9.5-1.7 1.4-2Z",
  store: "M4 9.5 5.4 5h13.2L20 9.5M4 9.5h16M4 9.5v9A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5v-9M4 9.5a2.5 2.5 0 0 0 4.6 1.2A2.5 2.5 0 0 0 12 11a2.5 2.5 0 0 0 3.4-.3A2.5 2.5 0 0 0 20 9.5M9.5 20v-5h5v5",
  cart: "M3.5 4.5h2l2.2 9.6a1.5 1.5 0 0 0 1.5 1.2h7.3a1.5 1.5 0 0 0 1.5-1.2L19.5 8H6m3.5 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  target: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-3.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z",
  compass: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm3.6-12.1-2 5.1-5.2 2 2-5.1 5.2-2Z",
  database:
    "M12 7.5c4.1 0 7.5-1 7.5-2.2S16.1 3 12 3 4.5 4 4.5 5.3 7.9 7.5 12 7.5Zm7.5-2.2v13.4c0 1.2-3.4 2.3-7.5 2.3s-7.5-1-7.5-2.3V5.3m15 6.7c0 1.2-3.4 2.2-7.5 2.2s-7.5-1-7.5-2.2",
  cpu: "M8 8h8v8H8V8Zm-2.5-1.5h13v11h-13v-11ZM9 3v3m6-3v3M9 18v3m6-3v3M3 9h3m-3 6h3m12-6h3m-3 6h3",
  bank: "M4 10h16M5.5 10v7m4-7v7m5-7v7m4-7v7M3.5 20h17M12 3.5 20.5 8h-17L12 3.5Z",
  coins:
    "M9 13.5c3 0 5.5-1 5.5-2.2V6.7C14.5 5.5 12 4.5 9 4.5S3.5 5.5 3.5 6.7v4.6c0 1.2 2.5 2.2 5.5 2.2Zm-5.5-6.8c0 1.2 2.5 2.2 5.5 2.2s5.5-1 5.5-2.2M9 13.5v3.8c0 1.2 2.5 2.2 5.5 2.2s5.5-1 5.5-2.2v-4.6c0-1.2-2.5-2.2-5.5-2.2m5.5 2.2c0 1.2-2.5 2.2-5.5 2.2-1 0-2-.1-2.7-.3",
  trophy:
    "M8 4h8v4.5a4 4 0 0 1-8 0V4Zm0 1H5.5v1.2A3.3 3.3 0 0 0 8.4 9.5M16 5h2.5v1.2a3.3 3.3 0 0 1-2.9 3.3M9.5 20h5m-2.5-3.5V20",
  trend: "M4 16.5 9.5 11l3.5 3.5L20 7m0 0h-4.5M20 7v4.5",
  pulse: "M3.5 12h3l2-6 3.5 12 2.5-8 1.6 4 1.4-2h3",
  clipboard:
    "M9 5H7.5A1.5 1.5 0 0 0 6 6.5v12A1.5 1.5 0 0 0 7.5 20h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 16.5 5H15M9 5a1.5 1.5 0 0 0 1.5 1.5h3A1.5 1.5 0 0 0 15 5M9 5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 5m-5 8 1.8 1.8L15.5 11",
  scale: "M12 4.5v15M7 19.5h10M4 9.5h16M6.5 9.5 4 15h5l-2.5-5.5Zm11 0L15 15h5l-2.5-5.5Z",
  globe: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm-8.5-8.5h17M12 3.5c2.2 2.3 3.4 5.3 3.4 8.5S14.2 18.2 12 20.5c-2.2-2.3-3.4-5.3-3.4-8.5S9.8 5.8 12 3.5Z",
  google:
    "M12 4.5c2 0 3.6.8 4.5 1.5l-1.8 1.8A4.6 4.6 0 0 0 12 7a5 5 0 1 0 4.8 6.3H12v-2.4h7.3c.1.5.2 1 .2 1.6 0 4.4-3 7.5-7.5 7.5a7.5 7.5 0 1 1 0-15Z",
  apple:
    "M15.6 12.4c0-2.2 1.8-3.3 1.9-3.4a4.1 4.1 0 0 0-3.2-1.7c-1.4-.1-2.7.8-3.4.8-.7 0-1.8-.8-2.9-.8a4.3 4.3 0 0 0-3.6 2.2c-1.6 2.7-.4 6.7 1.1 8.9.7 1.1 1.6 2.3 2.8 2.2 1.1 0 1.5-.7 2.9-.7 1.3 0 1.7.7 2.9.7 1.2 0 2-1.1 2.7-2.2a9 9 0 0 0 1.2-2.5c0-.1-2.4-1-2.4-3.5ZM13.4 5.6c.6-.7 1-1.7.9-2.6-.9 0-2 .6-2.6 1.3-.6.6-1 1.6-.9 2.6 1 0 2-.6 2.6-1.3Z",
};

const Icon = ({ name, size = 20, className = "", strokeWidth = 1.5, ...rest }) => {
  const d = paths[name];
  if (!d) return null;
  const filled = name === "play" || name === "google" || name === "apple";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
      {...rest}
    >
      <path d={d} />
    </svg>
  );
};

export default Icon;
